import COPY from './connect-finance-copy';

// Stripe names the weekly anchor in lowercase English. All seven, though the
// editors offer five: an anchor Stripe already holds is described whatever
// it is.
export const WEEKDAY_NAMES = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

// 1st, 2nd, 3rd, 4th … 11th, 12th, 13th … 21st. Null for anything that is
// not a day of a month, so the caller says the interval alone.
const ordinalDay = (day) => {
  if (!Number.isInteger(day) || day < 1 || day > 31) return null;
  const teens = day % 100 >= 11 && day % 100 <= 13;
  const suffix = teens ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
  return `${day}${suffix}`;
};

// Stripe's own words for the schedule, in the restaurant's — sourced from
// COPY so the admin support block reuses the exact same sentences instead of
// growing a second copy of them. Its own module because the balance hero and
// the admin block both need it and neither should import the other.
//
// The restaurant's row names the interval only (owner, 2026-10-22);
// `withDelay` is the admin support block's, which keeps the arrival delay.
export const describeSchedule = (balance, { withDelay = false } = {}) => {
  const interval = balance?.scheduleInterval;
  const schedule = COPY.balance.schedule;
  if (interval === 'daily') return withDelay ? schedule.dailyWithDelay(balance?.scheduleDelayDays) : schedule.daily;
  if (interval === 'weekly') return schedule.weekly(WEEKDAY_NAMES[balance?.scheduleWeeklyAnchor]);
  if (interval === 'monthly') return schedule.monthly(ordinalDay(balance?.scheduleMonthlyAnchor));
  if (interval === 'manual') return schedule.manual;
  return schedule.unknown;
};
